module.exports = __webpack_public_path__ + "img/10_no.68523357.svg";